import React from 'react';
import { Box, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import PerfectScrollbar from 'components/SafePerfectScrollbar';
import theme from 'theme';
import { InvalidCompaniesBoxProps } from './InvalidCompaniesBox.props';
import ModalItemCompanyBox from '../ModalItemCompanyBox/ModalItemCompanyBox';

const InvalidCompaniesBox = ({ companies, title }: InvalidCompaniesBoxProps) => (
  <Box marginTop="1rem">
    {!isEmpty(companies) && (
      <Typography
        gutterBottom
        style={{
          color: theme.palette.black,
          fontSize: '0.875rem',
          fontWeight: 700,
          textTransform: 'capitalize',
        }}>
        {title}
      </Typography>
    )}
    <PerfectScrollbar
      style={{
        maxHeight: '20rem',
        overflow: 'auto',
        padding: '0.5rem 0',
      }}
      options={{
        suppressScrollX: true,
      }}>
      {companies.map(company => (
        <ModalItemCompanyBox
          key={company.id}
          company={company}
          includeCheckbox={false}
          backgroundColor={theme.palette.grey[100]}
          padding="0.8rem"
        />
      ))}
    </PerfectScrollbar>
  </Box>
);

export default InvalidCompaniesBox;
